import { render, staticRenderFns } from "./apporve-request-for-sg.html?vue&type=template&id=33e288ca&scoped=true&external"
import script from "./apporve-request-for-sg.js?vue&type=script&lang=js&external"
export * from "./apporve-request-for-sg.js?vue&type=script&lang=js&external"
import style0 from "./apporve-request-for-sg.scss?vue&type=style&index=0&id=33e288ca&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e288ca",
  null
  
)

export default component.exports